import React, { useState } from "react";
import Accordian1 from "../../svgs/whitepaper/Accordian1";
import Accordian2 from "../../svgs/whitepaper/Accordian2";
import Accordian3 from "../../svgs/whitepaper/Accordian3";
import MobileAccordian1 from "../../svgs/whitepaper/MobileAccordian1";
import MobileAccordian2 from "../../svgs/whitepaper/MobileAccordian2";
import MobileAccordian3 from "../../svgs/whitepaper/MobileAccordian3";
import Chevron from "../../svgs/whitepaper/Chevron";
// import MobileChevron from "../../svgs/whitepaper/MobileChevron";
import { accordianItems } from "../../utils/accordianItems";

export default function Accordian() {
  const [open, setOpen] = useState(0);

  const accordians = [
    <Accordian1 color={open === 1 ? "#AE0000" : "#61FF00"} />,
    <Accordian2 color={open === 2 ? "#AE0000" : "#61FF00"} />,
    <Accordian3 color={open === 3 ? "#AE0000" : "#61FF00"} />,
  ];

  const mobileAccordians = [
    <MobileAccordian1 color={open === 1 ? "#AE0000" : "#61FF00"} />,
    <MobileAccordian2 color={open === 2 ? "#AE0000" : "#61FF00"} />,
    <MobileAccordian3 color={open === 3 ? "#AE0000" : "#61FF00"} />,
  ];

  const handleClick = (index) => {
    if (index === open) {
      setOpen(0);
    } else {
      setOpen(index);
    }
  };

  return (
    <div className="flex flex-col space-y-6 lg:space-y-20 mt-20 lg:mt-40 mb-20 lg:scale-75 xl:scale-100" >
      {accordianItems.map((accordian, index) => (
        <div className="flex flex-col items-center lg:w-[1240px] w-[325px]">
          <div
            className="relative w-full lg:h-[106px] h-10
          font-Helvetica text-xs lg:text-[30px] font-bold 
          flex items-center px-6 lg:px-14 justify-between"
          >
            <div className="absolute top-0 left-0 lg:block hidden">
              {accordians[index]}
            </div>
            <div className="absolute top-0 left-0 lg:hidden">{mobileAccordians[index]}</div>
            <div className="z-10 ">{accordian.title}</div>
            <div
              className={`cursor-pointer z-10 transition-all ${
                open === accordian.id ? "rotate-180" : ""
              }`}
              onClick={() => handleClick(accordian.id)}
            >
              <div className="scale-[0.4] lg:scale-100">
                <Chevron />
              </div>
            </div>
          </div>
          <div
            className={`transition-all ${
              open === accordian.id ? "block" : "hidden"
            } overflow-hidden p-8 lg:p-20 text-[9px] lg:text-lg`}
          >
            {accordian.content}
          </div>
        </div>
      ))}
    </div>
  );
}
